import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ProductService {

	constructor(private ws: PostmethodService) { }

	createProduct(request: any) {
		return this.ws.wsPost(request, environment.baseUrl + "products");
	}

	getProducts() {
		return this.ws.wsGet(environment.baseUrl + "products");
	}

	updateProduct(request: any, id: any) {
		return this.ws.wsPut(request, environment.baseUrl + "products", id);
	}

}